
  <!-- Content Wrapper. Contains page content -->
  <div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Assessment</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item"><a href="#">Home</a></li>
              <li class="breadcrumb-item active">Assessment</li>
            </ol>
          </div>
        </div>
      </div><!-- /.container-fluid -->
    </section>

    <!-- Main content -->
    <section class="content">
      <div class="container-fluid">
          <!-- Small boxes (Stat box) -->
      
          <div class="col-lg-12">
              
            
            <div class="card card-info">
                <div class="card-header">
                  <h3 class="card-title">Assessment Wise Performance</h3>
  
                  <div class="card-tools">
                    <button type="button" class="btn btn-tool" data-card-widget="collapse">
                      <i class="fas fa-minus"></i>
                    </button>
                   
                  </div>
                </div>
                <div class="card-body">
                  <div class="chart" *ngIf="barChartData">
                    <!-- <canvas id="lineChart" style="min-height: 250px; height: 250px; max-height: 250px; max-width: 100%;"></canvas> -->
                    <canvas baseChart style="min-height: 250px; height: 250px; max-height: 250px; max-width: 100%;"
                    [datasets]="barChartData" 
                    [labels]="barChartLabels" 
                    [options]="barChartOptions"
                    [colors]="barChartColors" 
                    [legend]="barChartLegend" 
                    [chartType]="barChartType" 
                    >
                </canvas>
                  </div>
                </div>
                <!-- /.card-body -->
              </div>
          </div>
        <div class="row">
          <div class="col-12">
            <div class="card card-outline card-danger">
              <!-- <div class="card-header">
                <h3 class="card-title">Fee Details</h3>
              </div> -->
              <!-- /.card-header -->
              <div class="card-body" >
                <table role="table" class="table table-hover">
                    <thead role="rowgroup">
                      <tr role="row" >
                        <th role="columnheader">#</th>
                      
                        <th role="columnheader">Assessment Name</th>
                        <th role="columnheader">Max</th>
                        <th role="columnheader">Min</th>
                        <th role="columnheader">Scored</th>
                        <th role="columnheader">%</th>
                    
                        <th role="columnheader"></th>
                       
                     
                      </tr>
                    </thead>
                    <tbody role="rowgroup" *ngFor="let fee of feedtls;let i = index">
                      <tr role="row">
                        <td role="cell">{{i+1}}</td>
                    
                        <td role="cell">{{fee.asnm}}</td>
                        <td role="cell">{{fee.Max}}</td>
                        <td role="cell">{{fee.Min}}</td>
                        <td role="cell">{{fee.Score}}</td>
                        <td role="cell">{{fee.Per}}%</td>
                       
                      
                    
                        <td role="cell">
                            <!-- <button type="button" class="btn btn-danger btn-sm" (click)="openpaymdl(mdlpay,fee)"  *ngIf="fee.Balance!=0">
                            <i class="fa fa-money-bill-alt"> </i> Pay</button>
                            <button type="button" class="btn btn-success btn-sm"  *ngIf="fee.Balance<=0">
                              <i class="fa fa-check">  </i>  Paid</button>                            -->
                        </td>
                        <!-- <th role="columnheader"> <button type="button" class="btn btn-success  btn-sm" *ngIf="fee.Balance==0">  
                          <i class="fa fa-download">  </i> Receipt
                      </button></th> -->
                      <!-- <td role="cell">
                        <ul>
                          <li>
                        <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right">
                          <span class="dropdown-item dropdown-header">15 Notifications</span>
                          <div class="dropdown-divider"></div>
                          <a href="#" class="dropdown-item">
                            <i class="fas fa-envelope mr-2"></i> 4 new messages
                            <span class="float-right text-muted text-sm">3 mins</span>
                          </a>
                          <div class="dropdown-divider"></div>
                          <a href="#" class="dropdown-item">
                            <i class="fas fa-users mr-2"></i> 8 friend requests
                            <span class="float-right text-muted text-sm">12 hours</span>
                          </a>
                          <div class="dropdown-divider"></div>
                          <a href="#" class="dropdown-item">
                            <i class="fas fa-file mr-2"></i> 3 new reports
                            <span class="float-right text-muted text-sm">2 days</span>
                          </a>
                          <div class="dropdown-divider"></div>
                          <a href="#" class="dropdown-item dropdown-footer">See All Notifications</a>
                        </div></li></ul>
                      </td> -->
               
                      </tr>
                   
                   
                    </tbody>
                  </table>


              </div>


             
              <!-- /.col -->
   


              



              <!-- /.card-body -->
            </div>
            <!-- /.card -->
        
          </div>
          <!-- /.col -->
        </div>
        <!-- /.row -->
      </div>
      <!-- /.container-fluid -->
     
    </section>
    <!-- /.content -->
  </div>
  <!-- /.content-wrapper -->

  